 import React, { createContext } from "react";
import intersection from "lodash/intersection";

import data from "static/data";

const dataObj = data.data;

/**
 * initial state
 */
export const AppContext = createContext({
  userAnswers: {},
  setAnswer: () => {},
  getAnswers: () => {},
});

/**
 * Provider
 */

export class AppProvider extends React.Component {
  state = {
    steps: dataObj[this.props.lang].steps,
    products: dataObj[this.props.lang].products,
    translations: dataObj[this.props.lang].translations,
    filters: dataObj[this.props.lang].filters,
    allAnswers: () => this.getAllAnswers(),
    userAnswers: {},
    userFilters: [],
    updateFilters: id => this.updateFilters(id),
    setAnswer: (key, value) => this.setAnswer(key, value),
    setFilter: id => this.setFilter(id),
    getAnswers: () => this.getAnswers(),
    getFilteredProducts: () => this.getFilteredProducts(),
    choices: [],
    choiceError: false,
    updateChoices: (id, value) => this.updateChoices(id, value),
    getChoices: () => this.getChoices(),
    removeChoice: id => this.removeChoice(id),
    choiceLimit: 5,
    t: key => this.translate(key),
    currentStep: 0,
    setCurrentStep: step => this.setCurrentStep(step),
    getFilterByTitle: title => this.getFilterByTitle(title),
  };

  getAllAnswers = () => {
    const allAnswers = [];
    this.state.steps.flatMap(({ questions }) => {
      allAnswers.push(questions.flatMap(question => question.answers));
    });
    return allAnswers.flat();
  };

  getChoices = () =>
    this.state.choices.map(choice => this.getProductById(choice)).sort(this.sortByPrice);

  setAnswer = (key, value) =>
    this.setState({ userAnswers: { ...this.state.userAnswers, [key]: value } });

  getAnswers = () => this.state.userAnswers;

  getProductById = id => this.state.products.find(product => product.id === id);

  getFilterByTitle = title => this.state.filters.find(filter => filter.title === title) || {};

  sortByPrice = (a, b) => {
    return b.intPrice - a.intPrice;
  };

  setCurrentStep = currentStep => {
    this.setState({ currentStep });
  };

  getFilteredProducts = () => {
    const allAnswers = this.getAllAnswers();
    const values = [];
    const userAnswers = Object.keys(this.state.userAnswers).flatMap(
      key => this.state.userAnswers[key],
    );
    userAnswers.forEach(userAnswer => {
      values.push(allAnswers.find(answer => answer.id === userAnswer).values);
    });
    this.state.userFilters.forEach(userFilter => {
      values.push(this.state.filters.find(filter => filter.id === userFilter).values);
    });
    const productsIds = intersection(...values);
    return productsIds.map(id => this.getProductById(id)).sort(this.sortByPrice);
    // return this.state.products.sort(this.sortByPrice);
  };

  updateChoices = (id, value) => {
    if (value) {
      this.addChoice(id);
    } else {
      this.removeChoice(id);
    }
  };

  addChoice = id => {
    if (!this.state.choices.includes(id) && this.state.choices.length < this.state.choiceLimit) {
      this.setState({ choices: [...this.state.choices, id], choiceError: false });
    } else if (this.state.choices.length >= this.state.choiceLimit) {
      this.setState({ choiceError: id });
    }
  };

  removeChoice = id => {
    if (this.state.choices.includes(id)) {
      this.setState({
        choices: this.state.choices.filter(choice => choice !== id),
        choiceError: false,
      });
    }
  };

  updateFilters = id => {
    if (this.state.userFilters.includes(id)) {
      this.setState({ userFilters: this.state.userFilters.filter(filter => filter !== id) });
    } else {
      this.setState({ userFilters: [...this.state.userFilters, id] });
    }
  };

  translate = key => {
    return this.state.translations[key];
  };

  render() {
    return <AppContext.Provider value={this.state}>{this.props.children}</AppContext.Provider>;
  }
}

/**
 * consumer
 */

export const AppConsumer = AppContext.Consumer;
